module.exports = __webpack_public_path__ + "static/media/lunchbox-screen.341ea5d2.png";